import React, { createContext, useContext, useState } from "react";

import useRefState from 'react-usestateref';


const customizeContext = createContext();

export const useCustomizeContext = () => useContext(customizeContext);

export const CustomizeProvider = ({ children }) => {

    // Loader 

    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [modal1, setModal1] = useState(false);
    const [modal2, setModal2] = useState(false);

    const [modal3, setModal3] = useState(false);
    const [modal4, setModal4] = useState(false);


    const [userToken, setUserToken] = useState('');
    const [forgetCode, setForgetCode] = useState('');


    const [isBet, setIsBet] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState([]);

    const [betId, setBetId, betIdRef] = useRefState("");
    const [mineId, setMineId, mineIdRef] = useRefState("");

    const [updateRes, setUpdateRes] = useState('');

    const [brlbal, setBrlbal] = useState("");


    // CRASH GAME 

    const [crashBetId, setCrashBetId, crashBetIdRef] = useRefState("");


    // Site Information 

    const [contact, setContact] = useState("");
    const [copyrightstext, setCopyrightstext] = useState("");
    const [copyrightstextPt, setCopyrightstextPt] = useState("");
    const [email, setEmail] = useState("");
    const [facebook, setFacebook] = useState("");
    const [instagram, setInstagram] = useState("");
    const [linkedIn, setLinkedIn] = useState("");
    const [discord, setDiscord] = useState("");
    const [siteLink, setSiteLink] = useState("");
    const [github, setGithub] = useState("");
    const [twitter, setTwitter] = useState("");
    const [youtube, setYoutube] = useState("");
    const [businessemail, setBusinessemail] = useState("");
    const [metakeyword, setMetakeyword] = useState("");
    const [metadescription, setMetadescription] = useState("");

    const [darkThemeLogo, setDarkThemeLogo] = useState("");

    const [favicon, setFavicon] = useState("");
    const [logo, setLogo] = useState("");

    const [language, setLanguage] = useState("");
    const [userName, setUserName] = useState("");
    const [profile, setProfile] = useState("");
    const [lightThemeIsActive, setLightThemeIsActive] = useState(false);
    const [mineMode, setMineMode] = useState("manual");
    const [balance, setBalance, balanceRef] = useRefState("");
    const [selectCurrency, setSelectCurrency] = useRefState("");
    const [hitCount, setHitCount] = useState(0);
    const [changeLanguageRes, setChangeLanguageRes] = useState("");
    const [languageType, setLanguageType] = useState("");


    const [searchGameRes, setGameSearchRes] = useState([]);
    const [searchIsActive, setSearchIsActive] = useState(false);
    const [searchText, setSearchText] = useState("");


    const [betModal, setBetModal] = useState(false);



    // Crash Game 


    const [crashMode, setCrashMode] = useState("manual");


    const [isActive, setIsActive] = useState(false);


    // Side Menu Active

    const [classIsActive, setClassIsActive] = useState(false);

    const [isOpen, setSideMenuOpen] = useState(false);
    const [isNetwork, setIsNetwork] = useState(false);





    const loader = {
        loading, setLoading,
    };

    const modelStatus = {
        modal, setModal,
        modal1, setModal1,
        modal2, setModal2,
        modal3, setModal3,
        modal4, setModal4,
    };


    const userAuthToken = {
        userToken, setUserToken
    };

    const siteInformation = {
        contact, setContact,
        copyrightstext, setCopyrightstext,
        copyrightstextPt, setCopyrightstextPt,
        email, setEmail,
        facebook, setFacebook,
        instagram, setInstagram,
        linkedIn, setLinkedIn,
        discord, setDiscord,
        siteLink, setSiteLink,
        github, setGithub,
        twitter, setTwitter,
        youtube, setYoutube,
        businessemail, setBusinessemail,
        metakeyword, setMetakeyword,
        metadescription, setMetadescription,
        logo, setLogo,
        favicon, setFavicon,
        darkThemeLogo, setDarkThemeLogo,
    };

    const forget = {
        forgetCode, setForgetCode,
    };

    const bet = {
        isBet, setIsBet,
        selectedCurrency, setSelectedCurrency,
        selectCurrency, setSelectCurrency,
        betId, setBetId, betIdRef,
        mineId, setMineId, mineIdRef,
        balance, setBalance, balanceRef,
        brlbal, setBrlbal
    };

    const apiResponses = {
        updateRes, setUpdateRes,
    };

    const mineGameMode = {
        mineMode, setMineMode,
    };

    const theme = {
        lightThemeIsActive, setLightThemeIsActive
    }

    const hitLength = {
        hitCount, setHitCount,
    }

    const languageContext = {
        language, setLanguage,
        changeLanguageRes, setChangeLanguageRes,
        languageType, setLanguageType,
    }

    const userInfo = {
        userName, setUserName,
        profile, setProfile,
    }

    // ---------------------  CRASH GAME CONTEXTS  -------------------//

    const crashGameMode = {
        crashMode, setCrashMode,
    }
    const crashBetContext = {
        crashBetId, setCrashBetId, crashBetIdRef,
    }
    const categoryMode = {
        isActive, setIsActive
    }

    const sideMenu = {
        classIsActive, setClassIsActive,
        isOpen, setSideMenuOpen
    }

    const gameSearch = {
        searchGameRes, setGameSearchRes,
        searchIsActive, setSearchIsActive,
        searchText, setSearchText,
    }

    const betHistoryModal = {
        betModal, setBetModal,
    }

    const networkStatus = {
        isNetwork, setIsNetwork,
    }

    return (
        <customizeContext.Provider value={{ categoryMode, networkStatus, sideMenu, betHistoryModal, gameSearch, languageContext, crashBetContext, crashGameMode, userInfo, loader, hitLength, modelStatus, theme, userAuthToken, bet, forget, apiResponses, siteInformation, mineGameMode }}>
            {children}
        </customizeContext.Provider>
    )
}